import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertTriangleIcon, BrainIcon, ShieldAlertIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-14 bg-white" data-id="element-132">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <FadeIn data-id="element-134">
          <div className="text-center mb-10" data-id="element-135">
            <h2 className="text-3xl md:text-4xl font-bold text-ink mb-6" data-id="element-136">
              El Enemigo Invisible en tu Despensa
            </h2>
            <div className="w-24 h-1 bg-leaf mx-auto rounded-full" data-id="element-137" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-138">
          <div className="bg-cream border border-forest/10 rounded-3xl p-8 md:p-12 mb-12 relative overflow-hidden" data-id="element-139">
            <div className="absolute top-0 right-0 w-64 h-64 bg-leaf/5 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-140" />

            <p className="text-xl md:text-2xl font-medium text-ink leading-relaxed relative z-10 text-center" data-id="element-141">
              Hoy en día, un niño promedio consume{' '}
              <strong className="text-forest" data-id="element-142">
                más azúcar antes de las 10:00 AM
              </strong>{' '}
              de la que nuestros abuelos consumían en una semana bajo la falsa
              promesa de "cereales nutritivos" y "jugos naturales".
            </p>
          </div>
        </FadeIn>

        <div className="space-y-8" data-id="element-143">
          <FadeIn delay={0.2} data-id="element-144">
            <p className="text-lg text-ink/80 leading-relaxed text-center" data-id="element-145">
              Esta sobrecarga constante de químicos y ultraprocesados no solo
              afecta sus dientes;{' '}
              <strong className="text-ink" data-id="element-146">hackea su cerebro</strong>. Es la
              causa silenciosa de:
            </p>
          </FadeIn>

          <div className="grid sm:grid-cols-3 gap-6 mt-8" data-id="element-147">
            <FadeIn delay={0.3} className="bg-cream p-6 rounded-2xl border border-forest/5" data-id="element-148">
              <BrainIcon className="w-8 h-8 text-leaf mb-4 mx-auto" data-id="element-149" />
              <h3 className="font-bold text-ink mb-2 text-center" data-id="element-150">
                Falta de Concentración
              </h3>
              <p className="text-ink/70 text-sm text-center" data-id="element-151">
                Dificultad para mantener la atención en clase debido a los picos
                de glucosa.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="bg-cream p-6 rounded-2xl border border-forest/5" data-id="element-152">
              <AlertTriangleIcon className="w-8 h-8 text-leaf mb-4 mx-auto" data-id="element-153" />
              <h3 className="font-bold text-ink mb-2 text-center" data-id="element-154">
                Berrinches de las 6 PM
              </h3>
              <p className="text-ink/70 text-sm text-center" data-id="element-155">
                Cambios de humor inexplicables causados por el colapso de
                energía vespertino.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} className="bg-cream p-6 rounded-2xl border border-forest/5" data-id="element-156">
              <ShieldAlertIcon className="w-8 h-8 text-leaf mb-4 mx-auto" data-id="element-157" />
              <h3 className="font-bold text-ink mb-2 text-center" data-id="element-158">
                Sistema Inmune Débil
              </h3>
              <p className="text-ink/70 text-sm text-center" data-id="element-159">
                Un cuerpo que parece rendirse ante cada nuevo virus que circula
                en la escuela.
              </p>
            </FadeIn>
          </div>

          <FadeIn delay={0.6} data-id="element-160">
            <div className="mt-8 p-6 bg-forest text-white rounded-2xl text-center font-medium text-lg shadow-xl font-[Montserrat,_sans-serif]" data-id="element-161">
              Estás tratando de construir un cuerpo humano desde cero, pero te
              han quitado el manual de instrucciones.
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}